import SlateValue from './slateValue/reducer';

export default {
  SlateValue
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js